module.exports = __webpack_public_path__ + "img/exit-stairs-width.a09a1426.svg";